import React from 'react'
import style from "../../Styles/car/info.module.css"
const Infodiv = () => {
  return (
    <div className={style.infocontainer}>
<h1>Inclusive for Free</h1>
<h1>Collision  Waiver Damage</h1>
<h1>Theif Protection</h1>
<h1>Cancellation </h1>

    </div>
  )
}

export default Infodiv